var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgHeadset = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6943 18.8074C19.3465 18.9852 18.9524 19.0855 18.535 19.0855H17.6075C16.1989 19.0855 15.057 17.9436 15.057 16.535V13.7526C15.057 12.344 16.1989 11.2021 17.6075 11.2021H19.6943V10.0427C19.6943 5.8169 16.2686 2.39119 12.0427 2.39119C7.8169 2.39119 4.39119 5.8169 4.39119 10.0427V11.2021H6.47798C7.88659 11.2021 9.02849 12.344 9.02849 13.7526V16.535C9.02849 17.9436 7.88659 19.0855 6.47798 19.0855H5.55052C4.1419 19.0855 3 17.9436 3 16.535V10.0427C3 5.04857 7.04857 1 12.0427 1C17.0369 1 21.0855 5.04857 21.0855 10.0427V16.535C21.0855 16.5536 21.0853 16.5721 21.0849 16.5906L21.0855 19.7539C21.0855 21.5467 19.6321 23 17.8394 23H11.798C11.4209 23 11.1153 22.6943 11.1153 22.3173C11.1153 21.9402 11.4209 21.6346 11.798 21.6346H17.8394C18.8638 21.6346 19.6943 20.8041 19.6943 19.7796V18.8074V18.8074ZM4.39119 12.5933V16.535C4.39119 17.1752 4.91024 17.6943 5.55052 17.6943H6.47798C7.11825 17.6943 7.6373 17.1752 7.6373 16.535V13.7526C7.6373 13.1123 7.11825 12.5933 6.47798 12.5933H4.39119ZM19.6943 12.5933H17.6075C16.9672 12.5933 16.4482 13.1123 16.4482 13.7526V16.535C16.4482 17.1752 16.9672 17.6943 17.6075 17.6943H18.535C19.1752 17.6943 19.6943 17.1752 19.6943 16.535V12.5933Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgHeadset;